import { formatDateSimple } from '@avanta/shared/utils/date';
import { SESSION_DISPLAY_FORMAT } from 'constants/date';
import { type Appointment } from 'types/appointments';
import { type PatientRecord } from 'types/patient';
import { formatUnifiedForDisplay } from 'utils/date';

export const PATIENT_RECORD_FIELD_KEY = {
  FECHA_BAJA: 'fecha_baja',
} as const;

const getRecordFieldValue = (record: PatientRecord, key: string): string | null => {
  const fromValues = record.values?.[key];
  if (typeof fromValues === 'string' && fromValues.trim()) return fromValues.trim();

  const fromFields = record.fields.find(field => field.key === key)?.value;
  if (typeof fromFields === 'string' && fromFields.trim()) return fromFields.trim();

  return null;
};

export const getActiveRecordCode = (record?: PatientRecord | null): string | null =>
  record?.code?.trim() || null;

export const getSickLeaveStartDate = (record?: PatientRecord | null): string | null => {
  if (!record) return null;

  const rawValue = getRecordFieldValue(record, PATIENT_RECORD_FIELD_KEY.FECHA_BAJA);
  if (!rawValue) return null;

  try {
    return formatDateSimple(rawValue);
  } catch {
    return rawValue;
  }
};

export const getLastSessionDisplay = (appointments: Appointment[]): string | null => {
  let latestAppointment: Appointment | null = null;

  for (const appointment of appointments) {
    if (appointment.canceled || !appointment.dateTime) continue;
    if (!latestAppointment || appointment.dateTime > latestAppointment.dateTime) {
      latestAppointment = appointment;
    }
  }

  if (!latestAppointment?.dateTime) return null;

  return formatUnifiedForDisplay(latestAppointment.dateTime, SESSION_DISPLAY_FORMAT);
};
